import { config } from '@onflow/fcl';
import { normalizeWalletName } from '../../utils/normalizeWalletName/normalizeWalletName.js';
import { FlowProvider } from './flow-provider.js';

class Blocto extends FlowProvider {
    constructor() {
        super(...arguments);
        this.name = 'Blocto';
        this.supportedChains = ['FLOW'];
        this.connectedChain = 'FLOW';
        this.canConnectViaQrCode = false;
        this.canConnectViaCustodialService = true;
        this.isWalletConnect = false;
    }
    get key() {
        return normalizeWalletName(this.name);
    }
    setupConfig() {
        super.setupConfig();
        config()
            .put('challenge.scope', 'email')
            .put('discovery.wallet', 'https://flow-wallet.blocto.app/authn')
            .put('service.OpenID.scopes', 'email!')
            .put('discovery.wallet.method', undefined);
    }
}

export { Blocto as default };
